<template>
    <div class='line' :class="{selectedLine: selectedLine}"  :data-word="typoObj.name" @click='$emit("selectLine")'  >
        <div class='col col1'>
            <a  @click='showTypo(typoObj.name)'  :title="'Consulter le dictionnaire typographique '+ typoObj.name">{{ typoObj.name }}</a>
        </div>
        <!--<div class='col col2'>
            <input type="checkbox" :id="'chk_'+typoObj.name" :value="typoObj.name" @click='updateTypoState()'> <!- - :checked='typoObj.installed ? true : null'>- ->
        </div>-->
        
        <div class='col col3' v-if="isSuperAdmin()">
            <button id="btnDelete" class="mdl-button mdl-js-button mdl-button--icon btn_deletesub" :disabled='typoObj.installed ? true : null' :title="'Supprimer le dictionnaire typographique '+typoObj.name" :data-typo="typoObj.name" @click='askDeleteTypo(typoObj.name)'><i class="material-icons">delete</i></button>
        </div>
        <button v-if="isSuperAdmin()" id="btnExport" class="mdl-button mdl-js-button mdl-button--icon" :title="'Télécharger le dictionnaire typographique '+typoObj.name" :data-typo="typoObj.name" @click='downloadTypo(typoObj.name)'><i class="material-icons">file_download</i></button>
    </div> 
</template>

<script>
    import axios from 'axios'
    import FctUtils from '@/components/FctUtils';
    import { RoleEnum } from '../classes/enums'
    import { diagonalbackURL, defaultConfig, OctetStreamConfig } from "../constantes";

    export default { 
        name:"TypoLine",
        mixins: [FctUtils],
        props:{
            settingObj:{type:Object},
            typoObj: {type:Object},
            selectedLine:{type:Boolean},
        },
        methods:{
            isSuperAdmin(){
                return this.$store.state.currentUser.role == RoleEnum.SUPERADMIN.value;
            },
            showTypo(aTypoName) {
                /*this.$router.push({name:"TypoFrame", params: {
                    typoname: aTypoName, 
                    settingObjStr : JSON.stringify(this.settingObj)
                } });*/
            },
            askDeleteTypo() {
                this.emitter.emit('showPLForm', {mode:'formTypo_remove', data:this.typoObj});
            },
            updateTypoState() {
                /*var url = diagonalbackURL + "/settings/"+ this.settingObj.id + "/dictionaries/" + this.typoObj.name;

                const params = JSON.stringify( {'install' : ""+!this.typoObj.installed});

                axios.post(url, params, defaultConfig)
                .then(reponse => {
                    this.typoObj.installed = !this.typoObj.installed;

                    this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
                })
                .catch(error => {
                    var aMsg = 'Echec lors de ';
                    if (!this.typoObj.installed) {
                        aMsg += 'l\'installation';
                    }
                    else {
                        aMsg += 'la mise en réserve'
                    }
                    aMsg += ' du dictionnaire '+ this.typoObj.name; 
                    
                    // on remet la checkbox dans le bon état
                    document.getElementById("chk_"+this.typoObj.name).checked = this.typoObj.installed;

                    alert(aMsg);
                });*/
            },
            downloadTypo(typoname) {
                var url = diagonalbackURL + "/settings/"+ this.settingObj.id + "/typography/dictionaries/" + typoname;

                axios(url, OctetStreamConfig)
                .then(response => {
                    this.downloadFile(typoname, response.data);
                })
                .catch(error => this.errorHandler(error));
            }

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.typo {
    display: inline-block;    
    margin:5px 0;
}

#btnExport {
    position: absolute;
    top: 5px;
    right: 5px;
    color: #0075bb;
}



</style>
